module.exports = __webpack_public_path__ + "img/podemos-peru.b74cd74d.png";